import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { reset, setAllPolicies, setTotal, setLoading } from './actions';

const totalReducer = handleActions(
  {
    [setTotal.toString()]: (_, { payload: total }) => total,
    [reset.toString()]: () => 0
  },
  0
);

const policiesReducer = handleActions(
  {
    [setAllPolicies.toString()]: (_, { payload: policies }) => policies,
    [reset.toString()]: () => []
  },
  []
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  total: totalReducer,
  policies: policiesReducer,
  loading: loadingReducer
});
